import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { FormGroup, FormBuilder } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { OpdVisitService } from 'app/opdvisits/Services/OpdVisit.service';
import { SiteloaderComponent } from 'app/auth/siteloader/siteloader.component';
import { AuthService } from 'app/auth/auth.service';
import { IPDService } from '../Services/ipdServices.service';
import { imageworkupService } from 'app/EMR/Image_workup/Services/Imageworkup.services';
import { WebSocketService } from 'app/EMR/webSocket.Service';

export interface DialogData {
  animal: string;
  name: string;
}

export interface FileUploadModel {
  documentname?: string;
  patientid?: number;
  fileinfo?: FormData;

}


@Component({
  selector: 'app-patient-document',
  templateUrl: './patient-document.component.html',
  styleUrls: ['./patient-document.component.scss']
})
export class PatientDocumentComponent implements OnInit {

  displayedColumns: string[] = ['filename', 'action'];
  //dataSource = ELEMENT_DATA;
  url = "./assets/img/noimage.png";
  documents: any[] = [];
  showspinner = false;
  selectedFile: File = null;
  filenotselected = true;
  isclosebtn: boolean;

  fileupload: FileUploadModel;
  documentname: string = "";
  filename: string = "No Files";
  setupload = true;
  setadddoc = true;
  baseurl: string;
  documentrul = [];
  loaderdialog;
  mainUrl: any;
  PatientId: any;
  folderName: string;
  folderName1: string;
  branchId: any;
  pk_ipdid: any;
  checkType: any;
  // public newbaseUrl:string;



  constructor(
    public dialogRef: MatDialogRef<PatientDocumentComponent>,
    public http: HttpClient, public authService: AuthService,
    public opdvisitService: OpdVisitService,
    public ipdservice: IPDService,
    public dashboardService: DashboardService,
    public dialog: MatDialog, private route: ActivatedRoute,
    @Inject(MAT_DIALOG_DATA) public data: DialogData, public imageWorkupService: imageworkupService, private webSocketService: WebSocketService) {
    dialogRef.disableClose = true;
    this.isclosebtn = true;

  }

  ngOnInit() {
    this.baseurl = this.dashboardService.newbaseUrl;
    this.folderName = ' ';
    this.folderName1 = ' ';
    this.pk_ipdid = 0;

    var Data: any = this.data;
    this.checkType = Data.checkboth;
    if (this.checkType == 0) {
      this.folderName = 'IPDDocument';
      this.PatientId = Data.PatinetId;
      this.isclosebtn = true;
      this.refreshdoc_list();
    } else if (this.checkType == 1) {
      this.opdvisitService.dataSource =[];
      this.folderName = 'PatientDocuments';
      this.PatientId = Data.PatinetId;
      this.pk_ipdid = Data.Ipdid;
      this.folderName1 = 'IPDDocument';
      this.isclosebtn = true;
      this.refreshdoc_list();
    }


    // this.documentURL();

  }
  setdoc_button() {

  }

  // seturl(element){
  //  this.url = this.mainUrl+"IPDDocument/" + this.PatientId + "/" + element;
  // }

  onFileSelected(event) {
    //console.log(event.target.files);
    this.selectedFile = <File>event.target.files[0];
    this.filename = this.selectedFile.name;

    this.filenotselected = false;

    if (event.target.files) {
      var reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = (event: any) => {
        this.url = event.target.result;
        this.setupload = false;
        //console.log("url get " + this.url);
      }
    }
  }

  open_loader_Dialog(): void {

    this.loaderdialog = this.dialog.open(SiteloaderComponent, {
      width: '300px',
      panelClass: 'site-loader',
      data: {
        // id: this.dashboardService.pid,
        //userid: this.authService.Loggeduser.userid
      }
    });

    this.loaderdialog.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      //pid = result;
    });
  }



  onUpload() {
    if (this.documentname == undefined) {
      this.documentname = "";
    }
    var chekImg: any;

    if (this.PatientId) {
      let fileToUpload = this.selectedFile;
      let fnsplit = this.selectedFile.name.split(".", 2);
      let actualdocumentname = this.documentname + "." + fnsplit[1];
      console.log(actualdocumentname);
      if (this.opdvisitService?.dataSource) {
        chekImg = this.opdvisitService?.dataSource?.find(o => o.documentName.toLowerCase() == actualdocumentname.toLowerCase());

      }
      console.log(chekImg);
      if (!chekImg) {
        //this.open_loader_Dialog();
        const formData = new FormData();
        // formData.append('file', fileToUpload, actualdocumentname);
        // formData.append('documentname', this.documentname);
        // formData.append('patientid', this.PatientId);
        // formData.append('branchId',this.authService.Loggeduser.branchid.toString());
        // formData.append('FolderNameMain',this.folderName);

        // this.imageWorkupService.uploadDoc(formData).subscribe(
        // data=> this.successfileupload(data), err=> this.failedfileupload(err)) 
        // }
        // else{
        // this.dashboardService.openSnackBar("This Document is Already Exist", "OK");
        // }
        if (this.authService.webstorageConfigobj.storageType != null && this.authService.webstorageConfigobj.storageType != undefined) {
          if (this.authService.webstorageConfigobj.documentFileSize != null && this.authService.webstorageConfigobj.documentFileSize != undefined && Number(this.authService.webstorageConfigobj.documentFileSize) > 0) {
            if (Number(this.authService.webstorageConfigobj.documentFileSize) * 1024 >= fileToUpload.size) {
              formData.append('file', fileToUpload, actualdocumentname);
              formData.append('documentname', this.documentname);
              formData.append('patientid', this.PatientId.toString());
              formData.append('branchId', this.authService.Loggeduser.branchid.toString());
              formData.append('DocumentType', this.folderName);
              formData.append('FolderNameMain', this.folderName);
              formData.append('UserId', this.authService.Loggeduser.userid.toString());
              formData.append('ActionType', "UPLOAD");
              formData.append('StorageType', this.authService.webstorageConfigobj.storageType);
              formData.append('DocumentURL', this.opdvisitService.mainUrl);
              if (this.authService.webstorageConfigobj.storageType.toLowerCase() == 'server') {
                this.open_loader_Dialog();
                this.imageWorkupService.uploadDoc(formData)
                  .subscribe(
                    data => this.successfileupload(data), err => this.failedfileupload(err))
              } else if (this.authService.webstorageConfigobj.storageType.toLowerCase() == 'azure') {
                this.open_loader_Dialog();
                this.imageWorkupService.uploadAzureDoc(formData)
                  .subscribe(
                    data => this.successfileupload(data), err => this.failedfileupload(err))
              } else if (this.authService.webstorageConfigobj.storageType.toLowerCase() == 'aws') {

              } else if (this.authService.webstorageConfigobj.storageType.toLowerCase() == 'imageserver') {

                var mainimagepath = this.opdvisitService.documentrul.filter(item => item?.propertyName.toLowerCase() == "mainimagepath");
                if (mainimagepath.length > 0) {
                  if (mainimagepath[0]?.propertyValue) {
                    const splitdata = this.url.split(',');
                    const message = {
                      "message": "UPLOADFILE",
                      "ACTIONTYPE": "UPLOAD",
                      "DOCUMENTTYPE": this.folderName.toUpperCase(),
                      "BranchId": this.authService.Loggeduser.branchid.toString(),
                      "PATIENTID": this.PatientId.toString(),
                      "MAINIMAGEPATH": mainimagepath[0]?.propertyValue,
                      "DOCUMENTNAME": String(actualdocumentname),
                      "CLIENTFILE": String(actualdocumentname),
                      "fileData": String(splitdata[1])
                    };

                    this.webSocketService.sendMessage(message);
                    this.webSocketService.getMessages().subscribe(
                      (message: any) => {

                        if (message) {
                          this.dashboardService.openSnackBar(message, "OK");
                          this.webSocketService.disconnect();
                          let payload = {
                            "PatientDocumentDetail": {
                              "ActionType": "UPLOAD",
                              "Pk_TranId": '0',
                              "Fk_BranchId": this.authService.Loggeduser.branchid.toString(),
                              "Fk_RegId": this.PatientId.toString(),
                              "Fk_CreatedById": this.authService.Loggeduser.userid,
                              "DocumentType": this.folderName.toUpperCase(),
                              "DocumentName": String(actualdocumentname),
                              "StorageType": this.authService.webstorageConfigobj.storageType,
                              "DocumentURL": mainimagepath[0]?.propertyValue + '/' + this.folderName.toUpperCase() + '/' + actualdocumentname
                            }
                          }
                          this.imageWorkupService.UpdatePatientDocumentDetail(payload).subscribe((x: any) => {
                            setTimeout(() => {
                              this.refreshdoc_list();
                            }, 500);

                          });

                        }

                      }, err => {

                        this.dashboardService.openSnackBar("Please set server configuration", "OK");
                      });
                  } else {
                    this.dashboardService.openSnackBar('Please set MainImagePath Property value in Application Setting', 'OK');
                  }
                } else {
                  this.dashboardService.openSnackBar('Please set MainImagePath in Application Setting', 'OK');
                }

              } else {
                this.dashboardService.openSnackBar("Please Check Storage Configuration", "OK");
              }
            } else {
              this.dashboardService.openSnackBar("Maximum File Size Allowed " + this.authService.webstorageConfigobj.documentFileSize + ' Kb', "OK");
            }
          } else {
            this.dashboardService.openSnackBar("Document File Size Not Configured", "OK");
          }
        } else {
          this.dashboardService.openSnackBar("Please Check Storage Configuration", "OK");
        }
      }
      else {
        this.dashboardService.openSnackBar("This Document is Already Exist", "OK");
      }
    }
    else {
      this.dashboardService.openSnackBar("Please Select Partient", "OK");
    }


  }


  // refreshdoc_list (){
  //    this.http.get<any>(this.ipdservice.newbaseUrl + "IPDDocument/GetAllFiles/" 
  //    + this.PatientId +'/'+ this.authService.Loggeduser.branchid).subscribe(
  //      data=> this.successdocs(data), err=> this.faileddocs(err) );
  //   }

  refreshdoc_list() {



    // if (this.authService.webstorageConfigobj.storageType.toLowerCase() == 'imageserver') {
    //   var mainimagepath = this.opdvisitService.documentrul.filter(item => item?.propertyName.toLowerCase() == "mainimagepath");
    //   if (mainimagepath.length > 0) {
    //     const msg = { "message": "UPLOADFILE", "ACTIONTYPE": "VIEW", "DOCUMENTTYPE": this.folderName.toUpperCase(), "BranchId": this.authService.Loggeduser.branchid.toString(), "PATIENTID": this.PatientId.toString(), "MAINIMAGEPATH": mainimagepath[0]?.propertyValue, }
    //     this.webSocketService.sendMessage(msg);
    //     this.webSocketService.getMessages().subscribe(
    //       (message: any) => {
    //         const filedat = message;
    //         if (filedat.length > 0) {
    //           this.opdvisitService.dataSource = message;
    //         }

    //       }, err => {
    //         this.dashboardService.openSnackBar("Please set server configuration", "OK");
    //       });
    //   } else {
    //     this.dashboardService.openSnackBar("Please set MainImagePath", "OK");
    //   }
    // } else {
    this.imageWorkupService.getAzureImagedata(this.PatientId, this.authService.Loggeduser.branchid, this.folderName).subscribe(
      (data: any) => {
        this.opdvisitService.dataSource = [];
        if(data.length >0){
          this.opdvisitService.dataSource = data.filter(item=>item.storageType.toLowerCase() ==this.authService.webstorageConfigobj.storageType.toLowerCase());
        }
        
        if (this.checkType == 1) {
          this.imageWorkupService.getAzureImagedata(this.pk_ipdid, this.authService.Loggeduser.branchid, this.folderName1).subscribe(
            (item: any) => {
              if (item.length > 0) {
                const newdata = this.opdvisitService.dataSource.concat(item);
                this.opdvisitService.dataSource = newdata.filter(item=>item.storageType.toLowerCase() ==this.authService.webstorageConfigobj.storageType.toLowerCase());
              }
            });
        }

      }, err => {
        this.dialog.closeAll();
      });
    // }
  }

  successdocs(data) {
    console.log('files', data)
    // let filterdata = data.filter(doc => doc != null);
    this.opdvisitService.dataSource = data;
    console.log('files data', this.opdvisitService.dataSource)
  }
  faileddocs(err) {

  }
  successfileupload(data) {
    console.log('upload', data);
    this.loaderdialog.close();
    this.setupload = true;
    this.url = "./assets/img/noimage.png";
    // this.showspinner = false;
    this.dashboardService.openSnackBar(this.selectedFile.name + " Uploaded Successfully", "OK");
    // this.opdvisitService.get_patient_docs();
    this.refreshdoc_list();
    console.log("file uploaded");

    this.filenotselected = true;
    this.documentname = "";
    this.selectedFile = null;

  }
  failedfileupload(err) {
    console.log('upload failed', err)
    this.dashboardService.openSnackBar(this.selectedFile.name + " Upload Failed", "OK");
    this.filenotselected = true;
    this.dialog.closeAll();
  }

  close() {
    this.dialogRef.close();
  }

  // deletedocument(element:string){
  //   console.log('id',element)
  // this.open_loader_Dialog();
  // this.ipdservice.deletePatientDocument(this.PatientId,element,this.authService.Loggeduser.branchid).subscribe(
  //  data => this.success_doc_delete(data), err=> this.failed_doc_delete(err)
  //  )
  // console.log ("delete doc " + element);
  // }

  deletedocument(element: any) {


    let payload = {
      "PatientDocumentDetail": {
        "ActionType": "DELETE",
        "Pk_TranId": element.pk_TranId,
        "Fk_BranchId": element.fk_BranchId,
        "Fk_RegId": element.fk_RegId,
        "Fk_CreatedById": this.authService.Loggeduser.userid,
        "DocumentType": element.documentType,
        "DocumentName": element.documentName,
        "DocumentURL": element.documentURL,
        "StorageType": element.storageType
      }
    }
    if (element.storageType.toLowerCase() == 'server') {
      this.open_loader_Dialog();
      this.ipdservice.deleteServerPatientDocument(payload).subscribe(
        data => this.success_doc_delete(data), err => this.failed_doc_delete(err));
    } else if (element.storageType.toLowerCase() == 'azure') {

      this.open_loader_Dialog();
      this.ipdservice.deleteAzurePatientDocument(payload).subscribe(
        data => this.success_doc_delete(data), err => this.failed_doc_delete(err));
    } else if (this.authService.webstorageConfigobj.storageType.toLowerCase() == 'imageserver') {
      this.ipdservice.deleteServerPatientDocument(payload).subscribe((x: any) => {
        var mainimagepath = this.opdvisitService.documentrul.filter(item => item?.propertyName.toLowerCase() == "mainimagepath");
        if (mainimagepath.length > 0) {
          const msg = {
            "message": "UPLOADFILE",
            "ACTIONTYPE": "DELETE",
            "DOCUMENTTYPE": element.documentType.toUpperCase(),
            "BranchId": element.fk_BranchId.toString(),
            "PATIENTID": element.fk_RegId.toString(),
            "DocumentName": element.documentName.toString(),
            "MAINIMAGEPATH": mainimagepath[0]?.propertyValue
          }
          this.webSocketService.sendMessage(msg);
          this.webSocketService.getMessages().subscribe(
            (message: any) => {
              if (message) {
                this.webSocketService.disconnect();
                this.refreshdoc_list();
                this.dashboardService.openSnackBar("Delete Successfully", "OK");
               
              }
            }, err => {
              this.dashboardService.openSnackBar("Please set server configuration", "OK");
            });
        } else {
          this.dashboardService.openSnackBar("Please set mainimagepath", "OK");
        }
      });

    }

  }

  success_doc_delete(data) {
    this.loaderdialog.close();
    this.dashboardService.openSnackBar("Document deleted successfully", "OK");
    this.refreshdoc_list();
    // this.dialog.closeAll();
  }

  failed_doc_delete(err) {
    this.dashboardService.openSnackBar("Delete api failed", "OK");
    this.dialog.closeAll();
  }

  getupdateDocStatus(element: any) {
    if (this.authService.webstorageConfigobj.storageType.toLowerCase() == 'imageserver') {
      // if (element.fbLong) {
      //   const splitdat = element.fbLong.split(/[:;,]+/);
      //   this.imageWorkupService.openBase64InBrowser(splitdat[3], splitdat[1], element.fName);
      // }
      var mainimagepath = this.opdvisitService.documentrul.filter(item => item?.propertyName.toLowerCase() == "mainimagepath");
      if (mainimagepath.length > 0) {
        const msg = { "message": "UPLOADFILE", "ACTIONTYPE": "VIEWFILE", "DOCUMENTNAME": element.documentName, "DOCUMENTTYPE": element.documentType.toUpperCase(), "BranchId": element.fk_BranchId.toString(), "PATIENTID": element.fk_RegId.toString(), "MAINIMAGEPATH": mainimagepath[0]?.propertyValue, }
        this.webSocketService.sendMessage(msg);
        this.webSocketService.getMessages().subscribe(
          (message: any) => {
            const filedat = message;
            if (Array.isArray(filedat)) {
              const splitdat = message[0].fbLong.split(/[:;,]+/);
              this.imageWorkupService.openBase64InBrowser(splitdat[3], splitdat[1], message[0].fName);

            }

          }, err => {
            this.dashboardService.openSnackBar("Please set server configuration", "OK");
          });
      } else {
        this.dashboardService.openSnackBar("Please set MainImagePath", "OK");
      }
    } else {
      let payload = {

        "TId": element.pk_TranId,
        "BId": element.fk_BranchId,
        "RId": element.fk_RegId,
        "FType": element.documentType,
        "FName": element.documentName,
        "FSType": element.storageType
      }
      this.imageWorkupService.insertgetImagepath(payload).subscribe((x: any) => {

        if (
          x.fbLong
        ) {
          const splitdat = x.fbLong.split(/[:;,]+/);
          this.imageWorkupService.openBase64InBrowser(splitdat[3], splitdat[1], x.fName);
        }
      });
    }
  }


  documentURL() {
    this.dashboardService.getdocument_url().subscribe(data => this.success_docurl(data), err => this.failed_docurl(err));
  }

  success_docurl(data) {
    this.documentrul = data;
    //  console.log(data)
    var urldoc = this.documentrul.filter(item => item.propertyName == "MainImagePathWebNetram")
    this.mainUrl = urldoc[0]?.propertyValue;
    this.refreshdoc_list();
  }
  failed_docurl(err) {

  }

}

